import { meta } from '../../constants/meta';
import { ChatsProvider } from '../../constants/types';

const ICON_BASE_URL = 'https://static.elfsight.com/icons/';

const DEFAULT_ICON = {
  [ChatsProvider.whatsapp]: `${ICON_BASE_URL}app-chats-whatsapp-chat-multicolor.svg`,
  [ChatsProvider.telegram]: `${ICON_BASE_URL}app-chats-telegram-chat.svg`,
  [ChatsProvider.instagram]: `${ICON_BASE_URL}chats-instagram-chat.svg`,
  [ChatsProvider.viber]: `${ICON_BASE_URL}app-chats-viber.svg`,
  [ChatsProvider.line]: `${ICON_BASE_URL}line.svg`,
  [ChatsProvider.discord]: `${ICON_BASE_URL}chats-discord.svg`,
  [ChatsProvider.facebook]: `${ICON_BASE_URL}app-chats-facebook-messenger.svg`,
  [ChatsProvider.all]: ``
  // [Provider.wechat]: `${ICON_BASE_URL}chats-wechat-chat.svg`, wechat doest exist in meta.provider
};

export const getDefaultBubbleIcon = () => ({
  url:
    DEFAULT_ICON[meta.provider] ||
    `${ICON_BASE_URL}app-chats-message-bubble-multicolor.svg`
});
